import EventEmitter from '../utils/EventEmitter';
import dispatcher from '../dispatcher';

var eventEmitter = new EventEmitter();
var items = {};

var timeForBlocking = 700;
var animationSpeed = 700;
var appearDelay = 0;
var setFocus = true;
var resetAfterScroll = false;

// timeForBlocking - время на которое будет заблокирована послайдовость
// animationSpeed - скорость смены слайдов
// appearDelay - задержка перед присвоением класса активному слайду

var nativeScroll = false;
var lastAdded = '';
var isBlocked = false;

var defaultProps = {
	timeForBlocking: timeForBlocking,
	animationSpeed: animationSpeed,
	appearDelay: appearDelay
};

var _handleEvent = function(e) {
	var setBlockTimer = false;

	if (e.type === 'slide-scroll:add') {
		if (items.hasOwnProperty(e.id)) return;

		lastAdded = e.id;
		items[e.id] = {
			id: e.id,
			index: e.index,
			total: e.total
		}

		eventEmitter.dispatch();
	}

	if (e.type === 'slide-scroll:update') {
		if (!items.hasOwnProperty(e.id)) return;

		if (e.total) {
			items[e.id].total = e.total;
		}
	}

	if (e.type === 'slide-scroll:remove') {
		if (!items.hasOwnProperty(e.id)) return;
		delete items[e.id];
	}

	if (e.type === 'slide-scroll:set-props') {
		if (e.hasOwnProperty('speed')) {
			animationSpeed = e.speed;
		}
		if (e.hasOwnProperty('block')) {
			timeForBlocking = e.block;
		}
		if (e.hasOwnProperty('delay')) {
			appearDelay = e.delay;
		}
	}

	if (e.type === 'slide-scroll:reset-props') {
		animationSpeed = defaultProps.animationSpeed;
		timeForBlocking = defaultProps.timeForBlocking;
		appearDelay = defaultProps.appearDelay;
	}

	if (e.type === 'slide-scroll:reset-props-after') {
		resetAfterScroll = true;
	}

	if (e.type === 'slide-scroll:unblock') {
		isBlocked = false;
	}

	if (e.type === 'slide-scroll:direction') {
		if (!items.hasOwnProperty(e.id)) return;
		if (isBlocked) return;

		if (e.direction === 'up') {
			if (items[e.id].index === 0) return;
			items[e.id].index--;
		}
		if (e.direction === 'down') {
			if (items[e.id].index === items[e.id].total - 1) return;
			items[e.id].index++;
		}

		if (e.hasOwnProperty('native')) {
			nativeScroll = e.native;
		}
		if (e.setFocus) {
			items[e.id].setFocus = true;
		}

		isBlocked = true;
		setBlockTimer = true;

		eventEmitter.dispatch();

		nativeScroll = false;
		items[e.id].setFocus = false;
	}

	if (e.type === 'slide-scroll:to') {
		if (isBlocked) return;
		if (!items.hasOwnProperty(e.id)) return;
		if (items[e.id].index === e.index) return;

		if (e.index < 0) {
			if (items[e.id].index === 0) return;
			items[e.id].index = 0;
		} else if (e.index > items[e.id].total - 1) {
			if (items[e.id].index === items[e.id].total - 1) return;
			items[e.id].index = items[e.id].total - 1;
		} else {
			items[e.id].index = e.index;
		}

		if (e.hasOwnProperty('native')) {
			nativeScroll = e.native;
		}
		if (e.setFocus) {
			items[e.id].setFocus = true;
		}

		isBlocked = true;
		setBlockTimer = true;

		eventEmitter.dispatch();

		nativeScroll = false;
		items[e.id].setFocus = false;
	}
	if (e.type === 'slide-scroll:enable') {
		if (items[e.id].active) return;
		items[e.id].active = true;

		eventEmitter.dispatch();
	}
	if (e.type === 'slide-scroll:disable') {
		if (!items[e.id].active) return;
		items[e.id].active = true;

		eventEmitter.dispatch();
	}

	if (setBlockTimer) {
		setTimeout(function() {
			setTimeout(function() {
				isBlocked = false;

				if (resetAfterScroll) {
					animationSpeed = defaultProps.animationSpeed;
					timeForBlocking = defaultProps.timeForBlocking;
					appearDelay = defaultProps.appearDelay;
					resetAfterScroll = false;
				}
			}, timeForBlocking);
		}, 0); // give it time to change props
	}
}

var getData = function() {
	return {
		items: items,
		timeForBlocking: timeForBlocking,
		animationSpeed: animationSpeed,
		appearDelay: appearDelay,
		nativeScroll: nativeScroll,
		lastAdded: lastAdded,
	}
}

var _init = function() {
	dispatcher.subscribe(_handleEvent);
}

_init();

export default {
	subscribe: eventEmitter.subscribe.bind(eventEmitter),
	unsubscribe: eventEmitter.unsubscribe.bind(eventEmitter),
	getData: getData
}